import { GROUP_REVIEW_USER } from '@app/constants'

type AuthModeArgs = {
  role?: string
  preview: boolean
  userId?: string | null
  classId?: string | null
  schoolId?: string | null
  districtId?: string | null
  organizationId?: string | null
}

export const getCustomTokenAuthMode = ({
  role,
  preview,
  userId,
  classId,
  schoolId,
  districtId,
  organizationId,
}: AuthModeArgs) => {
  const hasOrgIds = !!(classId || schoolId || districtId || organizationId)
  const groupMode = role !== 'Student' && !userId && (preview || hasOrgIds)

  return {
    groupMode,
    isPreviewMode: preview && groupMode,
  }
}

type PreviewAnswerKeyArgs = {
  preview: boolean
  groupMode: boolean
  userId?: string | null
}

export const shouldUsePreviewAnswerKeys = ({ preview, groupMode, userId }: PreviewAnswerKeyArgs) =>
  preview && groupMode && (!userId || userId === GROUP_REVIEW_USER)
